import useLocalStorage from '@rehooks/local-storage';
import React, {useEffect, useState} from 'react';
import * as Icon from 'react-feather';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../hooks/redux';
import {
    BrowserRouter as Router,
    Navigate,
    Route,
    Routes,
    useNavigate,
} from 'react-router-dom';

import {
    AppWrapper as AlchemyAppWrapperComponent,
    Badge as AlchemyBadgeComponent,
    Tooltip as AlchemyToolTipComponent,
} from '@amzn/alchemy-components-react';

// Type assertions to resolve React type conflicts
const AlchemyAppWrapper = AlchemyAppWrapperComponent as any;
const AlchemyBadge = AlchemyBadgeComponent as any;
const AlchemyToolTip = AlchemyToolTipComponent as any;

import { showModal } from '../slices/feedbackModalSlice';
import {UrlPath} from "../enums";
import i18n from "../i18n";
import stage from "../stages.const";
import {RootState} from "../types";

// Define interface for navigation items
interface NavItem {
    label: string;
    active: boolean;
    action: () => void;
}

// following are new components
import BookmarkView from './Bookmarks/BookmarkView';
import ErrorBoundary from './ErrorBoundary'
import FavoritesView from './Favorites/FavoritesView';
import Footer from "./Footer";
import NavbarBadge from './Navbar/NavbarBadge';
import SiteSelectionView from './Navbar/SiteSelectionView';
import SystemMessages from "./SystemMessage";

const Content = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [currentPath, setCurrentPath] = useState('')
    const [isMyFavoritesTabActived, setIsMyFavoritesTabActived] = useState(false)
    const currentUser = useSelector((state: RootState) => state.user)
    const mobileView = useSelector((state: RootState) => state.mobileView)
    
    function handleNavClick(destination: string) {
        switch (destination) {
            case "fav":
                navigate(UrlPath.MyFavorites)
                setCurrentPath(UrlPath.MyFavorites)
                break
            default:
                navigate(UrlPath.Bookmarks)
                setCurrentPath(UrlPath.Bookmarks)
        }
    }

    const navItems: NavItem[] = [
        { label: `${currentUser.login || "'s User"} ${i18n.t('universal:bookmarks')}`, active: isMyFavoritesTabActived, action: () => {handleNavClick("fav")} },
        { label: `${currentUser.whid || "WHID"} ${i18n.t('universal:bookmarks')}`, active: !isMyFavoritesTabActived, action: () => {handleNavClick("bmk")} }, ];

    let topNavItems: NavItem[] = []
    let sideNavItems: NavItem[] = []
    mobileView ? sideNavItems = navItems : topNavItems = navItems

    // TODO: need a graceful solution
    useEffect(() => {
        const windowPath = window.location.pathname;
        switch (windowPath) {
            case UrlPath.Bookmarks:
                setIsMyFavoritesTabActived(false)
                break;
            case UrlPath.MyFavorites:
                setIsMyFavoritesTabActived(true)
                break;
        }
        setCurrentPath(windowPath)
    }, [currentPath])

    if (stage !== "PROD") {
        document.title = `${currentUser.whid || 'loading'} | Amazon FC Bookmarks | ${stage}`;
    }

    function handleFeedbackClick() {
        dispatch(showModal(true))
    }

    return (<div className="d-flex flex-column h-100">
        <SystemMessages />
        <AlchemyAppWrapper
            headerLink="/"
            logoImage="/resources/img/bookmark-logo.svg"
            logoAltText="Amazon FC Bookmarks"
            topNav={topNavItems}
            sideNav={sideNavItems}
        >
            <main>
                <ErrorBoundary>
                    <Routes>
                        <Route path="/" element={<Navigate to={UrlPath.MyFavorites} replace />} />
                        <Route path={UrlPath.MyFavorites} element={<FavoritesView />} />
                        <Route path={UrlPath.Bookmarks} element={<BookmarkView />} />
                    </Routes>
                </ErrorBoundary>
                <Footer />
            </main>

            <div slot="topbar-actions" className="d-flex header">
                {/* site selector */}
                <div className="pl-1 pr-1 site-list d-flex flex-row topbar-custom-interaction">
                    <div>
                        {/* <Icon.MapPin size={14} /> */}
                        {i18n.t('nav:site')}: {currentUser.whid || "WHID"}</div>
                    <div className="site-list site-list-selector">
                        <SiteSelectionView />
                    </div>
                </div>
                {/* feedback icon */}
                <div onClick={handleFeedbackClick} className="pl-1 pr-1 topbar-custom-interaction">
                    <AlchemyToolTip>
                        <span slot="trigger">
                            <img style={{"height": "16px"}} src='/resources/img/thumbs-up.svg' />
                            <img style={{"height": "16px"}} src='/resources/img/thumbs-down.svg' />
                        </span>
                        <p className='mb-0'>
                            {i18n.t('feedback:title')}
                        </p>
                    </AlchemyToolTip>
                </div>
                {/* show user badge here. detail color has been override at topbar.scss*/}
                <div>
                    {/* {currentUser
                && <AlchemyBadge
                    label={currentUser.login || "Anonymous"}
                    image={`https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${currentUser.login || "Anonymous"}`}
                />} */}
                    <NavbarBadge />
                </div>
            </div>
        </AlchemyAppWrapper>
    </div>
    );
}

export default function() {
    return (
        <Router>
            <Content />
        </Router>
    );
}
